import RawMaterialHeader from "./Header";
import "./index.css";
import ProdComponentContents from "./ProdComponentContents";
import ProductTransportWrappingContents from "./ProductTransportWrapping";
import ProdWaterUsageContents from "./ProdWaterUsage";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const RawMaterialComponents = ({
  productId,
  showCategory,
  setShowCategory,
}) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const handleShowCategory = () => {
    setShowCategory(!showCategory);
  };

  return (
    <div className="raw-material-container" id="raw-material-id">
      <RawMaterialHeader productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <ProdComponentContents
          productId={productId}
          showCategory={showCategory}
          handleShowCategory={handleShowCategory}
          isCategory={true}
        />
      )}
      {show && <ProductTransportWrappingContents productId={productId} />}
      {show && <ProdWaterUsageContents productId={productId} />}
    </div>
  );
};

export default RawMaterialComponents;
